/* eslint-disable import/prefer-default-export */
import {
  FETCH_ZONES,
  FETCH_FIELDS,
  SAVE_ZONE_UPDATE,
  UPDATE_ZONE,
  QUICK_RUN,
  MULTIPLE_QUICK_RUN,
} from './types';

const fetchZoneAction = (payload) => ({
  type: FETCH_ZONES,
  payload,
});

const saveZoneAction = (payload) => ({
  type: SAVE_ZONE_UPDATE,
  payload,
});

const updateZoneAction = (payload) => ({
  type: UPDATE_ZONE,
  payload,
});

const quickRunAction = (payload) => ({
  type: QUICK_RUN,
  payload,
});

const multipleQuickRunAction = (payload) => ({
  type: MULTIPLE_QUICK_RUN,
  payload,
});

const fetchFieldsAction = () => ({
  type: FETCH_FIELDS,
});

export {
  fetchZoneAction,
  fetchFieldsAction,
  saveZoneAction,
  updateZoneAction,
  quickRunAction,
  multipleQuickRunAction,
};
